module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/75b8bac2584541c0e536f8bf8c65387e.png";